import React from 'react';
import {Icon} from 'components';
import {startCase} from 'helpers';
import css from './separator.module.scss';

export function Separator({ className, heading, icon, children, ...props }) {
  if (!heading && !children) {
    return null;
  }
  return (
    <p className={css('separator', className, props.onClick && 'clickable')} {...props}>
      { icon &&
        <Icon name={icon} />
      }
      { heading && startCase(heading) }
      { children || <u /> }
    </p>
  );
}
